import script from "./SubPaymentNumbers.vue?vue&type=script&setup=true&lang=js"
export * from "./SubPaymentNumbers.vue?vue&type=script&setup=true&lang=js"

import "./SubPaymentNumbers.vue?vue&type=style&index=0&id=007d2929&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-007d2929"]])

export default __exports__